import React from "react";
import TextField from "@material-ui/core/TextField";

type Props = {
  value: Record<string, unknown>;
  onChange: (newValue: Record<string, unknown>) => void;
};

export default function TestValue({value, onChange}: Props) {
  return (
    <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
      <TextField
        value={value.accessor}
        onChange={event => onChange({...value, accessor: event.target.value})}
        label="Key (eg: foo.bar)"
        variant="outlined"
        multiline={true}
        style={{width: "30em"}}
      />
      <TextField
        value={value.regex}
        onChange={event => onChange({...value, regex: event.target.value})}
        label="Value (regex, eg: ab*)"
        variant="outlined"
        multiline={true}
        style={{width: "30em"}}
      />
    </div>
  );
}
